import { gql } from '@apollo/client';
import atlAppraiserInfoFragment from './atlAppraiserInfoFragment';

const GET_AVAILABLE_ATLS = gql`
  query GetAvailableAtls($start: DateOnly!, $end: DateOnly!, $eventId: Int) {
    availableAtls(start: $start, end: $end, eventId: $eventId) {
      Atls {
        ...AtlAppraiserInfoFields
      }
      AtlCandidates {
        ...AtlAppraiserInfoFields
      }
    }
  }
  ${atlAppraiserInfoFragment}
`;

export default GET_AVAILABLE_ATLS;
